import React, { useEffect } from 'react';
import { RecallItems } from '../../../services/recalls-service/recalls-service';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { ExemptWordsListProps } from '../../pages/recalls/hook/use-exempt-word-list';
import './recalls-mobile-modal.scss';
import { KEYBOARD_KEYS } from '../../../constants';
import RecallReport from '../recall-report/recall-report';
interface Props {
    recall: RecallItems;
    content: RecallsUnitedContent;
    exemptWordsList?: ExemptWordsListProps | null;
    isCsp: boolean;
    onClose: (recall: RecallItems, showModal: boolean) => void;
    vin?: string | null;
    isWebview: boolean;
}
const RecallsMobileModal = (props: Props) => {
    const { recall, content, exemptWordsList, isCsp, isWebview } = props;
    const handleClose = () => {
        props.onClose({} as RecallItems, false);
    };
    useEffect(() => {
        const handleEscape = (event: any) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleEscape, { capture: true });
        nextFocus(`.close-recalls-mobile-modal-button`);
        return () => {
            document.removeEventListener('keydown', handleEscape, {
                capture: true,
            });
        };
    }, []);
    const nextFocus = (nextFocusClass: any) => {
        const nextFocusElement = document.querySelector(
            nextFocusClass
        ) as HTMLElement;
        nextFocusElement?.focus();
    };
    const keyDownOnModalBody = (event: any) => {
        if (event.key === KEYBOARD_KEYS.TAB) {
            event.preventDefault();
            nextFocus(`.close-recalls-mobile-modal-button`);
        }
    };

    return (
        <div className="recalls-mobile-modal-container">
            <div className="close-recalls-mobile-modal">
                <button
                    onClick={handleClose}
                    className="close-recalls-mobile-modal-button"
                    aria-label={content.closeRecallModalAriaLabel}
                    onKeyDown={event => {
                        if (event.key === KEYBOARD_KEYS.ENTER) {
                            event.preventDefault();
                            handleClose();
                        }
                        if (event.key === KEYBOARD_KEYS.TAB) {
                            event.preventDefault();
                            nextFocus(`.recall-report-container`);
                        }
                    }}
                >
                    <div className="close-recalls-mobile-modal-button-x" />
                </button>
            </div>
            <RecallReport
                recall={recall}
                content={content}
                isCsp={isCsp}
                exemptWordsList={exemptWordsList}
                onKeyDown={keyDownOnModalBody}
                vin={props.vin}
                isWebview={isWebview}
            />
        </div>
    );
};

export default RecallsMobileModal;
